import React from 'react'
import Editor from 'components/Editor'
import { Query } from 'react-apollo'
import { GET_IMAGE } from 'operations/Object'

const EditorContext = React.createContext(true)

class EditorProvider extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            image: null
        }
        this.handleToggle = this.handleToggle.bind(this)
    }

    handleToggle(image) {
        this.setState({
            isOpen: !this.state.isOpen,
            image
        })
    }

    render() {
        return(
            <EditorContext.Provider
                value={{
                    toggleEditor: this.handleToggle
                }}
            >
                {this.props.children}
                {
                    this.state.isOpen ? (
                        <Query query={ GET_IMAGE } variables={{ id: this.state.image }}>
                            {({ loading, error, data }) => {
                                if (loading) return 'Loading...';
                                if (error) return `Error! ${error.message}`;
                                
                                return (
                                    <Editor onClose={ this.handleToggle } object={ this.state.image } image={ data.image } />
                                );
                            }}
                        </Query>                        
                    ): null
                }                
            </EditorContext.Provider>
        )
    }

}

export {
    EditorContext,
    EditorProvider
}


// WEBPACK FOOTER //
// ./src/providers/Editor/index.js